import React, { useEffect, useState } from "react";
import Layout from "../../../../components/layouts/Layout";
import UserDetailHeader from "../../../../components/user-detail/UserDetailHeader";
import DataTable from "react-data-table-component";
// import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../../../../components/general/ProgressComponent";
import { GET_STAFF_SICKNESS_REPORT } from "../../../../env";
import Dropdown from 'react-bootstrap/Dropdown';
import * as XLSX from "xlsx";
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
import { PDFViewer } from '@react-pdf/renderer';
// import Dropdown from 'react-bootstrap/Dropdown';
// BlobProvider, Canvas, Circle, ClipPath, Defs, Document, Ellipse, Font, G, Image, Line, LinearGradient, Link, Note, PDFDownloadLink, PDFViewer, Page, Path, Polygon, Polyline, RadialGradient, Rect, Stop, StyleSheet, Svg, Text, TextInstance, Tspan, View, createRenderer, default, pdf, render, renderToBuffer, renderToFile, renderToStream, renderToString, usePDF, version
// import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Line } from '@react-pdf/renderer';
// import { PDFViewer } from '@react-pdf/renderer';
import {
    getRecords,
    isSuccess,
    filterColumns,
    filterRowsByProperty,
    displayEnumProperty,
    // toastErrorMessages,
    catchAsync,
    // toastSuccessMessages,

    addActivityLog,
} from "../../../../helper/helper";
import moment from "moment";

function ActiveStaffSicknessByMonth() {

    const months = moment.months(); // Array of month names
    const currentYear = moment().year();
    const currentMonth = moment().month() + 1;
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    const [filteredRows, setFilteredRows] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const [apiQuery, setApiQuery] = useState({
        startDate: 0,
        endDate: 0,
    });

    useEffect(() => {
        const start = moment(`${selectedYear}-${selectedMonth}-01`).startOf('month').valueOf();
        const end = moment(`${selectedYear}-${selectedMonth}-01`).endOf('month').valueOf();

        setApiQuery({
            startDate: start,
            endDate: end,
        });
    }, [selectedYear, selectedMonth]);

    const processFetchRecords = (method, data) => {
        if (data?.status !== isSuccess) {
            // toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
        } else if (method === "get" && data?.status === isSuccess) {

            const staffMembers = data?.data
            // setUserData(filteredRows);
            setFilteredRows(staffMembers);
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_STAFF_SICKNESS_REPORT, apiQuery);
        console.log("🚀 ~ fetchAllRecords ~ response:", response)

        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    useEffect(() => {
        fetchAllRecords();
    }, [apiQuery]);


    const columns = [
        {
            name: "#",
            selector: (row, index) => (
                <span >
                    {index + 1}
                </span>
            ),
            width: "5%",
            center: true,
        },
        {
            name: "Name",
            selector: (row) => {
                return (
                    <div
                        className="usersNameInfo py-2"
                    >
                        <span className="userInfo">
                            <span className="nameBlock">{`${row?.staffName}`}</span>
                        </span>
                    </div>
                );
            },
        },
        {
            name: "Month",
            selector: (row) => {
                return (
                    <>
                        <span className="text-capitalize">{row?.month}</span>
                    </>
                );
            },
            wrap: true,
        },
        {
            name: "No Absences",
            selector: (row) => {
                return (
                    <>
                        <span className="text-capitalize">{row?.noOfAbsences}</span>
                    </>
                );
            },
            center: true
        },
        {
            name: "No Absent Days",
            selector: (row) => {
                return (
                    <>
                        <span className="text-capitalize">{row?.totalDays}</span>
                    </>
                );
            },
            wrap: true,
            center: true
        },
    ];

    const filteredColumns = filterColumns(columns, (column) => column !== null);


    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };


    // Export Data

    const styles = StyleSheet.create({
        pages: {
            padding: "10px",
        },
        sectionTitle: {
            fontSize: "16px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        sectionSubTitle: {
            fontSize: "14px",
            fontWeight: "black",
            marginBottom: "5px",
            textAlign: "center",
            padding: "10px",
            backgroundColor: "#f0f0f0"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1,
        },
        tableHead: {
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#f0f0f0",
            padding: "10px 10px",
            marginBottom: "5px",
            fontSize: "10px",
            fontWeight: "bold",
            wordWrap: "break-word",
        },
        tabBody: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "10px 10px",
            borderBottom: "1px solid #ccc",
            fontSize: "10px",
            wordWrap: "break-word",
        },
        wordwrap: {
            flexBasis: "50%",
            wordWrap: "break-word",
        },
    });

    const MyDocument = (start) => (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.pages}>
                <View>
                    <Text style={styles.sectionTitle}>Active Staff Sickness Report by Month</Text>
                    <View style={styles.tableHead}>
                        <Text style={{ width: "25%" }}>Name</Text>
                        <Text style={{ width: "25%" }}>Month</Text>
                        <Text style={{ width: "25%" }}>No Absences</Text>
                        <Text style={{ width: "25%" }}>No Absent Days</Text>
                    </View>
                    {filteredRows.map((row, index) => (
                        <View key={index} style={styles.tabBody}>
                            <Text style={{ width: "25%" }}>
                                {row?.staffName}
                            </Text>
                            <Text style={{ width: "25%" }}>
                                {row?.month}
                            </Text>
                            <Text style={{ width: "25%" }}>{row?.noOfAbsences}</Text>
                            <Text style={{ width: "25%" }}>{row?.totalDays}</Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document >
    );

    const ExportButton = ({ data, data2, patientName, removeMoreColumns }) => {
        const handleExport = () => {
            // Preprocess data to format dates before exporting
            const formattedData = data.map(
                ({
                    ...item
                }) => {
                    const stafEmail = `${item?.user?.email || ""} `
                    removeMoreColumns.forEach((column) => {
                        delete item[column];
                    });

                    const stafDob = `${moment(item?.stafDob).format("DD/MM/YYYY") || ""} `


                    return {
                        ...item,
                    };
                }
            );

            const formattedData2 = [{ "Active Staff Sickness Report by Month": patientName }];

            const fileType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            const fileExtension = ".xlsx";
            const fileName = patientName;

            // Convert dataWithTitles array to worksheet
            let ws = XLSX.utils.json_to_sheet(formattedData2);

            // Add second data set to existing worksheet
            const ws2 = XLSX.utils.json_to_sheet(formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: true,
            });

            XLSX.utils.sheet_add_json(ws, formattedData, {
                header: Object.keys(formattedData[0]),
                skipHeader: false,
                origin: -1,
            });

            // Create workbook
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

            // Write workbook to array buffer
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

            // Convert array buffer to Blob
            const blob = new Blob([excelBuffer], { type: fileType });

            // Create download link and trigger download
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = fileName + fileExtension;
            a.click();
            // Add activity log AFTER download
            addActivityLog({
                message: `Download in Excell`,
                module: "Active Staff Sickness Report by Month",
            });
        };

        return <span onClick={handleExport}>Export as xlsx</span>;
    };
    return (
        <>
            <Layout pageTitleText="Active Staff Sickness Report by Month">
                <header className="headerContainerSearchAction">
                    <div className="actionButtons">
                        <div className="gap-1">
                            <a className="btn btn-sm btn-primary" href="/reports">
                                Back to Reports
                            </a>
                            <>
                                {
                                    filteredRows.length > 0 && (
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-success" size="sm" id="dropdown-basic">
                                                Export Data
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="exportDataList">
                                                <>
                                                    <span className="">
                                                        <PDFDownloadLink document={<MyDocument columns={columns} data={filteredColumns} />} fileName={"Active Staff Sickness Report by Month"}>
                                                            {({ loading }) =>
                                                                loading ? (
                                                                    "..."
                                                                ) : (
                                                                    <span
                                                                        onClick={() =>
                                                                            addActivityLog({
                                                                                message: "Download in PDF",
                                                                                module: "Active Staff Sickness Report by Month",
                                                                            })
                                                                        }
                                                                    >
                                                                        Export as PDF
                                                                    </span>
                                                                )
                                                            }
                                                        </PDFDownloadLink>
                                                    </span>
                                                    <span className="">
                                                        <ExportButton data={filteredRows} patientName={"Active Staff Sickness Report by Month"} removeMoreColumns={["contractedHours", "kin", "user", "managerId", "__v", "DBSCertificate", "photographicIdentification", "proofOfAddress", "rightToWork", "preScreen", "cv", "interviewForm", "offerLetter", "applicationForm", "supervisorId", "references", "bankDetailsForm", "personalDetailsForm", "hourOptOutForm", "healthDeclaration", "equalOpportunities", "BYODSignedDeclaration", "proofOfNationalInsurance", "_id", "active", "createdAt", "updatedAt", "archiveDate", "staffStartDate", "niNumber", "stafDob"]} />
                                                    </span>
                                                </>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                }
                            </>
                        </div>
                    </div>
                    <div className="payrollSubHeader m-0">
                        <div className="payrollDateFilter">
                            <div className={`customSelectBox form-group m-0`}>
                                <select value={selectedMonth} onChange={handleMonthChange}>
                                    {months.map((month, index) => (
                                        <option key={index} value={index + 1}>
                                            {month}
                                        </option>
                                    ))}
                                </select>
                                <label className="floatingLabel">
                                    Month
                                </label>
                            </div>
                            <div className={`customSelectBox form-group m-0`}>
                                <select value={selectedYear} onChange={handleYearChange}>
                                    {[...Array(5)].map((_, i) => (
                                        <option key={i} value={currentYear - i}>
                                            {currentYear - i}
                                        </option>
                                    ))}
                                </select>
                                <label className="floatingLabel">
                                    Year
                                </label>
                            </div>
                        </div>
                    </div>
                </header>

                {/* <PDFViewer style={{ width: "100%", height: "300px" }}>
                    <MyDocument />
                </PDFViewer> */}
                <div className="mainContent noCursorPointer">
                    <div className="dataTableWrapper staffRecordsGroupsTable">
                        <DataTable
                            className="maxWidthTable"
                            columns={filteredColumns}
                            data={filteredRows}
                            fixedHeader
                            fixedHeaderScrollHeight="520px"
                            highlightOnHover
                            responsive={true}
                            subHeaderWrapperProps={{ style: { padding: 0, margin: 0 } }}
                            progressPending={isLoading}
                            progressComponent={<ProgressComponent />}
                        />
                    </div>
                </div>
            </Layout >
        </>
    );
}

export default ActiveStaffSicknessByMonth;
